/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { AddressFragmentDoc } from '../../../../graphql/fragments/CustomerData.generated';
import { ValidationErrorResponseFragmentDoc } from '../../../../screens/ReorderingScreen/GraphQL/Reorder.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddAddressV2Input = {
  readonly city: string;
  /** 2 letter country code */
  readonly country: string;
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly latitude: number;
  readonly longitude: number;
  readonly name?: string | null | undefined;
  readonly notes?: string | null | undefined;
  readonly secondaryStreet?: string | null | undefined;
  /** 2 letter state code */
  readonly state: string;
  readonly street: string;
  readonly zipCode: string;
};

export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type AddDeliveryAddressV2MutationVariables = Exact<{
  input: Types.AddAddressV2Input;
}>;

export type AddDeliveryAddressV2Mutation = {
  readonly addAddressV2:
    | {
        readonly __typename: 'AddAddressSuccess';
        readonly address: {
          readonly __typename: 'Address';
          readonly id: string;
          readonly street: string;
          readonly secondaryStreet: string | null;
          readonly name: string | null;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly country: string;
          readonly deliveryPreference: Types.DeliveryPreferenceType;
          readonly googlePlaceId: string;
          readonly latitude: number;
          readonly longitude: number;
          readonly notes: string | null;
        };
      }
    | { readonly __typename: 'InvalidAddress'; readonly message: string; readonly status: number }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const AddDeliveryAddressV2Document = gql`
  mutation addDeliveryAddressV2($input: AddAddressV2Input!) {
    addAddressV2(input: $input) {
      __typename
      ... on AddAddressSuccess {
        address {
          ...address
        }
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${AddressFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useAddDeliveryAddressV2Mutation() {
  return Urql.useMutation<AddDeliveryAddressV2Mutation, AddDeliveryAddressV2MutationVariables>(
    AddDeliveryAddressV2Document,
  );
}
